export default "__VITE_ASSET__36853b93__"